export default __webpack_public_path__ + "static/media/europe_text.c4042af8.png";